import { removeUndefinedKeys } from '../../lib/removeUndefinedKeys';
/* istanbul ignore next: todo: test */
export var mapCommandAddressToCheckoutLegacyAddress = function (data) {
    var _a, _b;
    return removeUndefinedKeys({
        addressLine1: data.addressLine1,
        addressLine2: data.addressLine2,
        addressesServiceId: null,
        city: data.city,
        company: data.company,
        country: data.country,
        email: data.email,
        fullName: "".concat((_a = data.name.firstName) !== null && _a !== void 0 ? _a : '', " ").concat((_b = data.name.lastName) !== null && _b !== void 0 ? _b : ''),
        name: { firstName: data.name.firstName, lastName: data.name.lastName },
        phoneNumber: data.phoneNumber,
        street: data.street,
        subdivision: data.subdivision,
        taxInfo: data.taxInfo,
        zipCode: data.zipCode,
    });
};
//# sourceMappingURL=mapCommandAddressToCheckoutAddress.js.map